import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateVisit } from "../hooks";
import { VisitForm } from "../components";

export const CreateVisit: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const { form, submit, loading } = useCreateVisit({
    defaultValues: {
      customerId: customerId ? +customerId : undefined,
    },
    onCompleted: () => {
      toast.success("La visite a été créée avec succès");
      if (customerId) {
        navigate(`/customer/${customerId}`);
      }
    },
  });

  useEffect(() => {
    if (customerId) {
      form.setValue("customerId", +customerId);
    }
  }, [customerId]);

  return (
    <>
      <Header
        title="Visite"
        subtitle="Créer une nouvelle visite"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/visits`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle visite" />
          <VisitForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
